<div fxFlex class="box">
  <div class="header">
    <div class="section-title">Product Rules</div>
    <div fxFlex></div>
    <div class="search" [ngClass]="{'active': searchTerm}">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input type="text" matInput placeholder="" autocomplete="off" (keyup)="searchProductRule()" [(ngModel)]="searchTerm">
      </mat-form-field>
    </div>
    <button mat-button color="primary" type="button" (click)="addProductRule()"
      matTooltip="Add product">
      <mat-icon>add</mat-icon> Add rule
    </button>

  </div>
  <form class="content" #formProductRules="ngForm">
    <ngx-datatable (sort)="onSort()" #datatable class="material" [rows]="productRules" [columnMode]="ColumnMode.force" [sortType]="SortType.single"
      [headerHeight]="35" [rowHeight]="'auto'">

      <ngx-datatable-column name="Product" [sortable]="true" prop="productName" [resizeable]="false" [canAutoResize]="true">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-multi-labels searchKey="productName" (changed)="onProductsChanged($event)" [labels]="row.products"
            [availableLabelsQuery]="filteredProducts" name="products"
          [placeholder]="'Products'"></app-multi-labels>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [name]="getScoreTitle()" required [sortable]="true" prop="score" [width]="120" [resizeable]="false" [canAutoResize]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <mat-form-field [ngClass]="{'hidden': !row.visible}">
            <mat-label>{{ getScoreTitle() }}</mat-label>
            <input matInput type="number"required min="0" max="100" step=".01"
              (input)="onInput($event, row, 'score')" [value]="row.score" autocomplete="off" name="score_{{row.guid}}">
          </mat-form-field>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [sortable]="false" [width]="50" [resizeable]="false" [canAutoResize]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <lib-button [ngClass]="{'hidden': !row.visible}" fxFlex (buttonClick)="removeProductRule(row.guid)" color="primary" type="button"
            tooltip="Remove product rule" icon="delete">
          </lib-button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    @if (searchTerm) {
      <mat-error>Showing <strong>{{searchCount}}</strong>/{{productRules.length}}</mat-error>
    }
    @if (productRulesInvalid() | async) {
      <mat-error>One or more rules are invalid</mat-error>
    }

  </form>
</div>